import './audio/mute-switch.js';
import './application/game-application.js';
import { registerInstallCache } from './offline/install-cache.js';

registerInstallCache();
